import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './TagList.st.css.js';
import Tag from '../Tag';
import TagListAction from './TagListAction';
import ToggleMoreButton from './ToggleMoreButton';
import { DATA_HOOKS } from './TagList.constants';
const buttonSize = {
    small: 'tiny',
    medium: 'small',
    large: 'medium',
};
const TagList = ({ dataHook, tags, actionButton, size = 'small', onTagRemove, maxVisibleTags = 3, toggleMoreButton, initiallyExpanded = false, }) => {
    const [isExpanded, setIsExpanded] = useState(initiallyExpanded);
    const visibleTags = isExpanded ? tags : tags.slice(0, maxVisibleTags);
    const actionButtonSize = buttonSize[size];
    const toggleExpanded = useCallback(() => {
        setIsExpanded(previous => !previous);
    }, []);
    const renderToggleMoreButton = useCallback(() => {
        const amountOfHiddenTags = tags.length - maxVisibleTags;
        if (toggleMoreButton && amountOfHiddenTags > 0) {
            return (React.createElement(ToggleMoreButton, { size: actionButtonSize, toggleMoreButton: toggleMoreButton, amountOfHiddenTags: amountOfHiddenTags, isExpanded: isExpanded, dataHook: DATA_HOOKS.toggleMoreButton, onClick: toggleExpanded }));
        }
        return null;
    }, [
        isExpanded,
        maxVisibleTags,
        actionButtonSize,
        tags.length,
        toggleExpanded,
        toggleMoreButton,
    ]);
    return (React.createElement("div", { className: classes.root, "data-hook": dataHook },
        visibleTags.map(({ className, ...tagProps }) => (React.createElement(Tag, { ...tagProps, className: st(classes.item, className), size: size, onRemove: onTagRemove, key: tagProps.id }))),
        renderToggleMoreButton(),
        actionButton && (React.createElement(TagListAction, { dataHook: DATA_HOOKS.actionButton, size: actionButtonSize, onClick: actionButton.onClick }, actionButton.label))));
};
TagList.displayName = 'TagList';
TagList.propTypes = {
    dataHook: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.object),
    onTagRemove: PropTypes.func,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    initiallyExpanded: PropTypes.bool,
    maxVisibleTags: PropTypes.number,
    actionButton: PropTypes.shape({
        onClick: PropTypes.func,
        label: PropTypes.string,
    }),
    toggleMoreButton: PropTypes.func,
};
export default TagList;
//# sourceMappingURL=TagList.js.map